<template>
  <div class="watermark-wrapper">
    <!-- Courses Admin Start -->
    <div class="section overflow-hidden position-relative" id="wrapper">

      <!-- Page Content Wrapper Start -->
      <div class="page-content-wrapper padding-left-0">
        <div class="container-fluid custom-container">

          <!-- Message Start -->
          <div class="dashboard-head">
            <div class="message-content">
              <h2>Detailed Test Result</h2>
              <p>View comprehensive insights and analysis of your test results in detail..</p>
            </div>
          </div>
          <!-- Message End -->

          <!-- Admin Courses Tab Content Start -->
          <div class="admin-courses-tab-content">
            <div class="tab-content" v-if='results'>
              <div class="tab-pane fade show active">

                <!-- Courses Item Start -->
                <div class="courses-item padding-12">

                  <div class="content-title">
                    <h3 class="title"><a href="#" class="margin-top-0">Final Test Result</a></h3>
                  </div>

                  <div class="content-wrapper">

                    <div class="content-box margin-top-0 width-200">
                      <p>Test Date</p>
                      <span class="count">{{ formatDate(results.test_attempt_date) }}</span>
                    </div>

                    <div class="content-box margin-top-0">
                      <p>Correct Answers</p>
                      <span class="count">
                        {{ results.correct_ans }}
                      </span>
                    </div>

                    <div class="content-box margin-top-0">
                      <p>Incorrect Answers</p>
                      <span class="count">
                        {{ results.result.length - results.correct_ans }}
                      </span>
                    </div>

                  </div>
                </div>
                <!-- Courses Item End -->

                <!-- Admin Courses Tab Content Start -->
                <div class="admin-courses-tab-content">
                  <div class="tab-content">
                    <!-- <div class="courses-item" v-for='(result, index) in results.result' :key='result._id'>
                      <div>
                        <p class="question">{{ index + 1 }}) {{ result.ques.question }}</p>
                        <img v-if="result.ques.question_image" :src="get_img(result.ques._id)" alt="Question Image"
                          class="question-img mb-2" width="400" />

                        <p v-for="(option, index) in result.ques.options" :key="index" :class="[
                          'options', // Always applied
                          index === result.ques.ans ? 'correct-answer' : '',
                          result.ans !== -1 && index === result.ans && result.ans !== result.ques.ans ? 'incorrect-answer' : ''
                        ]">
                          {{ String.fromCharCode(65 + index) }}) {{ option }}
                        </p>

                        <p class="badge" v-if='result.ans == result.ques.ans'> User answered correctly </p>
                        <p class="badge" v-if='result.ans == -1'> User didnt attempt </p>
                        <p class="badge" v-if='result.ans !== -1 && result.ans !== result.ques.ans'> User answered
                          incorrectly </p>

                      </div>
                    </div> -->
                    <div>
                      <div
                        class="courses-item"
                        v-for="(result, idx) in paginatedResults"
                        :key="result._id"
                      >
                        <div>
                          <p class="question">
                            {{ (currentPage - 1) * itemsPerPage + idx + 1 }}) {{ result.ques.question }}
                          </p>
                          <img
                            v-if="result.ques.question_image"
                            :src="get_img(result.ques._id)"
                            alt="Question Image"
                            class="question-img mb-2"
                            width="400"
                          />
                          <p
                            v-for="(option, index) in result.ques.options"
                            :key="index"
                            :class="[
                              'options',
                              index === result.ques.ans ? 'correct-answer' : '',
                              result.ans !== -1 && index === result.ans && result.ans !== result.ques.ans
                                ? 'incorrect-answer'
                                : '',
                            ]"
                          >
                            {{ String.fromCharCode(65 + index) }}) {{ option }}
                          </p>
                          <p class="badge" v-if="result.ans === result.ques.ans">
                            User answered correctly
                          </p>
                          <p class="badge" v-else-if="result.ans === -1">User did not attempt</p>
                          <p class="badge" v-else>User answered incorrectly</p>
                        </div>
                      </div>

                      <Pagination
                        :totalPages="totalPages"
                        v-model:currentPage="currentPage"
                      />
                    </div>

                  </div>

                </div>
                <!-- Courses Item End -->

              </div>
            </div>
          </div>
          <!-- Admin Courses Tab Content End -->

        </div>
      </div>
      <!-- Page Content Wrapper End -->

    </div>

    <!-- Watermark logos in star pattern -->
    <div class="watermark">
      <img src="/assets/images/original-logo.png" alt="Logo" class="logo-1">
      <img src="/assets/images/original-logo.png" alt="Logo" class="logo-2">
      <img src="/assets/images/original-logo.png" alt="Logo" class="logo-3">
      <img src="/assets/images/original-logo.png" alt="Logo" class="logo-4">
      <img src="/assets/images/original-logo.png" alt="Logo" class="logo-5">
    </div>
  </div>
</template>

<script>
import { AppConfig } from '@/constants';
import { fetchTestResult } from '@/services/resultService';
import Pagination from "@/components/reusable/Pagination.vue";
export default {
  name: 'TestResults',
  components: {
    Pagination,
  },
  data() {
    return {
      results: null,
      currentPage: 1,
      itemsPerPage: 1,
    }
  },
  mounted() {
    this.get_results();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.results.result.length / this.itemsPerPage);
    },
    paginatedResults() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.results.result.slice(start, start + this.itemsPerPage);
    },
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(date);
    },
    async get_results() {
      this.results = await fetchTestResult(this.$route.params.id);
      console.log(this.results);
    },
    get_img(id) {
      return AppConfig.API_BASE_URL + `/test/get_question_image/${id}`;
    },
    
  },
};
</script>

<style>
.badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #ffffff;
  /* White text color */
  background-color: #2d3436;
  /* Indigo background color */
  border-radius: 0.375rem;
  /* Rounded corners */
}

/* Watermark styles */
.watermark-wrapper {
  position: relative;
}

.watermark {
  position: absolute;
  top: 392px;
  left: 0;
  width: 100%;
  height: calc(100% - 392px);
  pointer-events: none;
  z-index: 0;
}

.watermark img {
  position: absolute;
  width: 120px;
  opacity: 0.2;
}

/* Top-left */
.logo-1 {
  top: 80px;
  left: 120px;
}

/* Top-right */
.logo-2 {
  top: 80px;
  right: 120px;
}

/* Center */
.logo-3 {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Bottom-left */
.logo-4 {
  bottom: 80px;
  left: 120px;
}

/* Bottom-right */
.logo-5 {
  bottom: 80px;
  right: 120px;
}
</style>